
import { Clock } from "lucide-react";

const HistoireHero = () => {
  return (
    <div className="relative overflow-hidden">
      <div
        className="bg-cover bg-center h-[500px] flex items-center relative"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(140, 198, 63, 0.8), rgba(98, 146, 158, 0.8)), url('/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png')`
        }}
      >
        {/* Decorative elements */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-32 h-32 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 bg-white rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl text-white">
            <div className="flex items-center mb-6">
              <Clock className="h-8 w-8 mr-3 text-white" />
              <span className="text-lg font-medium opacity-90">Depuis 1987</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-heading font-bold mb-6 leading-tight">
              NOTRE HISTOIRE
            </h1>
            <p className="text-xl md:text-2xl leading-relaxed max-w-3xl">
              Plus de 35 ans d'engagement pour l'environnement, découvrez l'évolution du Groupe Fabre Environnement
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg px-6 py-3">
                <span className="text-2xl font-bold">35+</span>
                <p className="text-sm opacity-90">Années d'expérience</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg px-6 py-3">
                <span className="text-2xl font-bold">9</span>
                <p className="text-sm opacity-90">Sites</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg px-6 py-3">
                <span className="text-2xl font-bold">80</span>
                <p className="text-sm opacity-90">Collaborateurs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Enhanced decorative wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg 
          className="relative block w-full h-[80px]" 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 1440 120" 
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#8CC63F" stopOpacity="0.3" />
              <stop offset="50%" stopColor="#62929E" stopOpacity="0.2" />
              <stop offset="100%" stopColor="#385E71" stopOpacity="0.1" />
            </linearGradient>
          </defs>
          <path 
            fill="url(#waveGradient)" 
            d="M0,32L80,42.7C160,53,320,75,480,74.7C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
          />
          <path 
            fill="#ffffff" 
            d="M0,48L80,58.7C160,69,320,91,480,90.7C640,91,800,69,960,64C1120,59,1280,69,1360,74.7L1440,80L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default HistoireHero;
